var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer-bottom" }, [
    _c("div", { staticClass: "footer-bottom--row grid--row" }, [
      _c("div", { staticClass: "footer-bottom--left grid--col" }, [
        _c("footer", [
          _c("small", [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.title) +
                "\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer-bottom--right grid--col" }, [
        _c("h2", { staticClass: "footer-bottom--title u-reset" }, [
          _vm._v(_vm._s(_vm.addressTitle))
        ]),
        _vm._v(" "),
        _c("p", {
          staticClass: "footer-bottom--paragraph",
          domProps: { innerHTML: _vm._s(_vm.address) }
        }),
        _vm._v(" "),
        _c("nav", { staticClass: "footer-bottom--links" }, [
          _c(
            "ul",
            { staticClass: "footer-bottom--collection u-reset" },
            _vm._l(_vm.links, function(link, index) {
              return _c(
                "li",
                { key: index, staticClass: "footer-bottom--item" },
                [
                  _c(
                    "conditional-link",
                    _vm._b(
                      { staticClass: "link-list--link u-reset" },
                      "conditional-link",
                      link,
                      false
                    ),
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(link.label) +
                          "\n                        "
                      )
                    ]
                  )
                ],
                1
              )
            })
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-084f1ad8", { render: render, staticRenderFns: staticRenderFns })
  }
}